export const environment = {
  production: true,
  url:"https://multicomer.backend.scc.quosoluciones.com.ar/api/"
};
